import React, { useState, useEffect } from 'react';

export default function BackToTop({ translations }) {
  const [isVisible, setIsVisible] = useState(false);

  // Sayfanın kaydırma konumunu izle
  const handleScroll = () => {
    // 300px'den fazla kaydırıldığında butonu göster
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Sayfanın en üstüne yumuşak kaydır
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 bg-gray-600 hover:bg-gray-700 text-white p-3 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-110 z-50"
        aria-label={translations.backToTop}
        title={translations.backToTop}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    )
  );
}
